export const ANONYMOUS_ONLY_SEGMENT_ID = 'anonymousVisitorsOnly';

export const SIGNAL_TYPES = Object.freeze({
    RETENTION: 'retention',
    ADOPTION: 'adoption',
    VISITOR_ADOPTION: 'visitorAdoption',
    VISITOR_ENGAGEMENT: 'visitorEngagement',
    VISITOR_RAGE_CLICKS: 'visitorRageClicks',
    EVENT_ADOPTION: 'eventAdoption',
    EVENT_RAGE_CLICKS: 'eventRageClicks',
    VISITOR_RETENTION: 'visitorRetention',
    ACCOUNT_RETENTION: 'accountRetention',
    NPS_WEEK_OVER_WEEK: 'npsWeekOverWeek',
    VISITOR_ACQUISITION: 'visitorAcquisition',
    STICKINESS: 'stickiness',
});

export const SIGNAL_TYPE_ORDER = Object.freeze([
    SIGNAL_TYPES.VISITOR_ADOPTION,
    SIGNAL_TYPES.NPS_WEEK_OVER_WEEK,
    SIGNAL_TYPES.VISITOR_ENGAGEMENT,
    SIGNAL_TYPES.VISITOR_RAGE_CLICKS,
    SIGNAL_TYPES.EVENT_RAGE_CLICKS,
    SIGNAL_TYPES.STICKINESS,
    SIGNAL_TYPES.VISITOR_RETENTION,
    SIGNAL_TYPES.ACCOUNT_RETENTION,
    SIGNAL_TYPES.EVENT_ADOPTION,
    SIGNAL_TYPES.VISITOR_ACQUISITION,
]);
